import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const BreadCrumbContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  color: ${props => (props.isLast ? props.theme.colors.text.default : props.theme.colors.outline.default)};
  cursor: ${props => (props.isClickable ? 'pointer' : 'default')};
`
